import GetFeedbackByCompanyIdRequestModelBase from '../_generated/modelBases/get-feedback-by-company-id-request-model-base';

export default class GetFeedbackByCompanyIdRequestModel extends GetFeedbackByCompanyIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
